// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q4/2021pension_brand/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRules = () => {
  return http.get(`${urlPrefix}rules`);
};

const getRadio = () => {
  return http.get(`${urlPrefix}getType`);
};

const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const list = (id: string | number, page: number, search: string) => {
  return http.get(
    `${urlPrefix}vote-list&workType=${id}&page=${page}&search=${search}`,
  );
};

const detail = (id: any) => {
  return http.get(`${urlPrefix}detail&id=${id}`);
};

export { getBaseInfo, getRules, getRadio, save, list, detail };
